import * as React from 'react';

// Types
import { UserTypes } from '../types';

type ViewingAsProviderProps = {
    userType: UserTypes;
    children?: React.ReactNode;
};

export interface IViewingAsContext {
    userType?: UserTypes;
}

export const ViewingAsContext: React.Context<IViewingAsContext> = React.createContext({});

export const ViewingAsProvider: React.FC<ViewingAsProviderProps> = ({
    children,
    userType = UserTypes.AUTHENTICATED,
    ...props
}) => {
    return <ViewingAsContext.Provider value={{ userType }}>{children}</ViewingAsContext.Provider>;
};
